export default "__VITE_ASSET__B5ItjT5H__"